export default __webpack_public_path__ + "static/media/KOD0072-min.b7a69102.webp";